export const blockIconsSocialPersonOutline = (
	<span className='material-symbols-outlined'>person_outline</span>
);
